import { render, staticRenderFns } from "./CompareNames.vue?vue&type=template&id=d5435854&"
import script from "./CompareNames.vue?vue&type=script&lang=ts&"
export * from "./CompareNames.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports